import * as React from 'react';

import {ButtonIcon} from '../../icon/button-icon';
// @ts-expect-error - imported from .js/.jsx file
import {ColumnPickerIcon} from '../../icon/svg/column-picker-icon';

import styles from './column-picker-button.module.css';

type Props = {
    // TODO: Make this work, maybe needs newer than flow 0.53?
    // ...HTMLButtonElement,
    withBackground?: boolean;
};

export function ColumnPickerButton(props: Props) {
    const {withBackground, ...htmlButtonProps} = props;

    return (
        <div className={styles.container}>
            <button
                {...htmlButtonProps}
                type='button'
                className={withBackground ? styles['button--background'] : styles.button}
            >
                <ButtonIcon size='normal' variant='text-primary' icon={ColumnPickerIcon} /> Change
                columns
            </button>
        </div>
    );
}
